import { CellAction } from "./cell-action";

import { News } from "@/src/data/types";
import { ColumnDef } from "@tanstack/react-table";
import { showDate } from "../../../lib/dateFormater";

export const columns: ColumnDef<News>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
    cell: ({ row }) => {
      const { title, isDraft } = row.original;
      return (
        <div className="flex items-center gap-2">
          <span>{title}</span>
          {isDraft && (
            <span className="inline-flex items-center rounded-full bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800 border border-yellow-300">
              Brouillon
            </span>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "description",
    header: "DESCRIPTION",
    cell: ({ row }) => {
      const message = row.original.description;

      const parser = new DOMParser();
      const doc = parser.parseFromString(message, "text/html");
      const plainText = doc.body.textContent || "";

      return plainText.length > 10 ? `${plainText.slice(0, 10)}...` : plainText;
    },
  },
  {
    accessorKey: "date",
    header: "DATE",
    cell: ({ row }) => {
      return showDate(row.original.date);
    },
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
